import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useAppContext } from '@/context/app'
import { Spinner } from '@/components/spinner'
import { Roles } from '@/services/repository/users'
import { useModal } from '@/components/modal/Modal'
import { groupLabel } from '@/components/usergroup/group'
import { SuperAdminInsertUserGroupPopup } from '@/pages/for/superadmin/usergroups/groups'
import { useWizard } from '@/common/wizard/wizard'
import { WizardData } from './data'

export interface SimpleUserGroup {
  id: string
  name: string
  namespaceName?: string
}

export const CreateUserWizardStep1 = () => {
  const { services, session, translates } = useAppContext()
  const { openModal } = useModal()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const [usergroups, setUsergroups] = useState<SimpleUserGroup[]>()
  const [selectedGroupId, setSelectedGroupId] = useState<string | undefined>(wizardData.usergroupId)

  function refresh() {
    services.session.fetchWithToken(`/api/communal/usergroups/my`).then((response) => {
      return response.json()
    }).then((data) => {
      setUsergroups(data)
    })
  }

  useEffect(refresh, [])

  const isManager = useMemo(
    () => session ? [Roles.SuperAdmin, Roles.HyperAdmin, Roles.CompanyAdmin, Roles.CompanyManager, Roles.Accountant].includes(session.user.role as any) : false,
    [session]
  );

  if (translates === undefined || wizardData === undefined) {
    return <Spinner />
  }

  return <>
    <div>
      <h3>{translates.for('popup.create_user_wizard.select_usergroup_title')}</h3>
      {/* {isManager ? <div className='left-btns'>
        <button className="popup-add" onClick={() => openModal((props) => <SuperAdminInsertUserGroupPopup {...props} services={services} session={session!} onInsert={(group: SimpleUserGroup) => {
            // refresh()
            setSelectedGroupId(group.id)
            updateWizardData({
              userGroup: group.id
            })
            nextStep()
          }} />)}>
          {translates?.for('popup.create_user_wizard.add_usergroup')}
        </button>
      </div> : null} */}

      <ul className="usergroup-list">
        {usergroups ? usergroups?.map((group) => (
          <li
            key={group.id}
            className={selectedGroupId === group.id ? 'selected' : ''}
            onClick={() => {
              setSelectedGroupId(group.id)
              updateWizardData({
                usergroupId: group.id
              })
              nextStep()
            }}
          >
            {groupLabel(group)}
          </li>
        )) : <Spinner />}
      </ul>
      {selectedGroupId ? <div className='right-btns'>
        <button className='btn btn-next' onClick={nextStep}>{translates.for('popup.create_user_wizard.next')}</button>
      </div> : null}
    </div>
  </>
}

